export const environment = {
  production: false,
  // Deployed dev API Gateway base URL.
  // Fill this in after a dev deploy, e.g. https://xxxx.execute-api.us-east-1.amazonaws.com
  // Cognito supplier pool + app client (doyourshades-supplier-dev).
  cognitoUserPoolId: "us-east-1_HmM0buhf5",
  cognitoClientId: "2i52eh74scna92g5a1s08hivdn",
  apiBaseUrl: "https://bhtdl1s1oc.execute-api.us-east-1.amazonaws.com",
};
